import React from 'react';
import { Navbar, NavbarHref, NavbarLink, NavbarSpacer } from '@app/core';
import { useTranslation } from 'react-i18next';
import { Feature, useCapabilities, useIsAdmin } from '@app/api';
import { useUnlockFeature, useIsSpecialOfferPageActive } from 'components';
import { OrganizationSwitcher } from './OrganizationSwitcher';

interface Props {
  children?: React.ReactNode;
}

export const MainDashboardPage = ({ children }: Props) => {
  const { i18n, t } = useTranslation();
  const capabilities = useCapabilities();
  const unlockPanel = useUnlockFeature(Feature.CUSTOM_PANEL);
  const isAdmin = useIsAdmin();
  const isSpecialOfferActive = useIsSpecialOfferPageActive();

  return (
    <Navbar
      pageContent={children}
      color="accent"
      logo={<OrganizationSwitcher />}
    >
      <NavbarSpacer />
      <NavbarLink
        to="/"
        end
        icon="ri-dashboard-line"
        label={t('sessions.list.title')}
      />

      {isAdmin || capabilities?.customPanel ? (
        <NavbarLink
          to="/panel"
          icon="ri-group-line"
          label={t('participants.list.title')}
        />
      ) : (
        <NavbarLink
          onClick={unlockPanel}
          icon="ri-group-line"
          label={t('participants.list.title')}
        />
      )}

      {!!isAdmin && (
        <NavbarLink
          to="/new-panel"
          icon="ri-gift-line"
          label={t('participants.list.title')}
        />
      )}

      {!!isAdmin && (
        <NavbarLink
          to="/quote"
          icon="ri-file-text-line"
          label={t('quote.title')}
        />
      )}

      {!!isSpecialOfferActive && (
        <NavbarLink
          to="/special-offer"
          icon="ri-flashlight-line"
          label={t('billing.specialOffer.shortTitle')}
          color="red"
          emph
        />
      )}

      <NavbarLink
        to="/billing-dashboard"
        icon="ri-coins-line"
        label={t('billing.dashboard.title')}
      />

      <NavbarSpacer />
      <NavbarHref
        icon="ri-question-line"
        href={
          i18n.language === 'fr'
            ? 'https://tandemz.crisp.help/fr/category/aide-pour-les-ux-researchers-tz6rni/'
            : 'https://tandemz.crisp.help/en/category/researcher-helpdesk-187k8mc/'
        }
      />
      <NavbarLink
        to="/settings"
        icon="ri-settings-3-line"
        label={t('settings.title')}
      />
    </Navbar>
  );
};
